import CompaniesContainer from 'modules/companies/containers/CompaniesContainer';

const CompaniesView = props => <CompaniesContainer {...props} />;

export default CompaniesView;
